var _path, _circle, _circle2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3067 1.4684C10.6943 1.09337 11.3096 1.09337 11.6972 1.4684L12.8467 2.58034C13.29 3.00926 13.9065 3.20958 14.5173 3.12318L16.1008 2.89921C16.6349 2.82367 17.1326 3.1853 17.2258 3.71658L17.5021 5.29176C17.6087 5.89937 17.9897 6.4238 18.5347 6.71293L19.9474 7.46248C20.4239 7.71528 20.614 8.30042 20.3771 8.785L19.6748 10.2218C19.4038 10.776 19.4038 11.4242 19.6748 11.9784L20.3771 13.4152C20.614 13.8998 20.4239 14.4849 19.9474 14.7377L18.5347 15.4873C17.9897 15.7764 17.6087 16.3008 17.5021 16.9084L17.2258 18.4836C17.1326 19.0149 16.6349 19.3765 16.1008 19.301L14.5173 19.077C13.9065 18.9906 13.29 19.1909 12.8467 19.6199L11.6972 20.7318C11.3096 21.1068 10.6943 21.1068 10.3067 20.7318L9.15725 19.6199C8.71388 19.1909 8.09737 18.9906 7.48656 19.077L5.90309 19.301C5.36902 19.3765 4.87127 19.0149 4.77808 18.4836L4.50177 16.9084C4.39519 16.3008 4.01417 15.7764 3.46923 15.4873L2.05653 14.7377C1.58005 14.4849 1.38993 13.8998 1.62681 13.4152L2.32914 11.9784C2.60006 11.4242 2.60006 10.776 2.32914 10.2218L1.62681 8.78501C1.38993 8.30042 1.58005 7.71528 2.05653 7.46248L3.46923 6.71293C4.01417 6.4238 4.39519 5.89937 4.50177 5.29176L4.77808 3.71658C4.87127 3.1853 5.36902 2.82367 5.90309 2.89921L7.48656 3.12318C8.09737 3.20958 8.71388 3.00926 9.15725 2.58034L10.3067 1.4684Z",
    fill: "#D90D0D",
    stroke: "#D90D0D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 7.6001,
    r: 1.75,
    stroke: "white",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 14.6001,
    r: 1.75,
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5876 6.56862C15.8464 6.24517 15.7939 5.7732 15.4705 5.51445C15.147 5.25569 14.6751 5.30813 14.4163 5.63158L15.5876 6.56862ZM6.4163 15.6316C6.15754 15.955 6.20999 16.427 6.53343 16.6857C6.85688 16.9445 7.32885 16.8921 7.5876 16.5686L6.4163 15.6316ZM14.4163 5.63158L6.4163 15.6316L7.5876 16.5686L15.5876 6.56862L14.4163 5.63158Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.210a035bbd5b832c9c653265ea82e23a.svg";
export { ForwardRef as ReactComponent };